/*
 * Thanks: Sushyant Zavarzadeh (http://zavarzadeh.org)
 */
t_jp.l={
    'Close without saving?': 'بدون نگه داری ببندیم؟',
    'You have made a change to the translation. Are you sure you want to discard it?': 'شما در ترجمه یک دگرگونی ساخته اید آیا آگاهانه می خواهید آن را دور بیندازید؟ ',
    'History': 'پیشینه',
    'Loading...': 'بارگیری...',
    'Translated': 'ترجمه شده',
    'By': 'با',
    'At': 'در',
    'google': 'گوگل',
    'bing': 'بینگ',
    'apertium': 'اِی پِرشِم',
    'manual translation': 'ترجمه ی دستی',
    'bing suggest': 'پیشنهاد بینگ',
    'google suggest': 'پیشنهاد گوگل',
    'apertium suggest': 'پیشنهاد اِی پِرشِم',
    'Edit Translation': 'ویرایش ترجمه',
    'Original text': 'نوشته ی پایه',
    'read alternate translations': 'خواندن ترجمه های جایگزین',
    'previous translation': 'ترجمه ی پیشین',
    'find on page': 'یافتن در برگه',
    'next translation': 'ترجمه ی (بعدی) پسین',
    'Translate to': 'ترجمه به',
    'view translation log': 'دیدن رویدادهای ترجمه',
    'virtual keyboard': 'کیبورد مجازی',
    'approve translation': 'پذیرش ترجمه',
    'delete': 'پاک کردن',
    'Discard': 'دور انداختن',
    'Cancel': 'پرهیز'
};